import { useDispatch, useSelector } from "react-redux";
import { Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../../Redux/LanguageSlice";
import { RootState } from "../../Redux/store";
import { useEffect } from "react";

const LanguageSelector = () => {
  const dispatch = useDispatch();
  const currentLang = useSelector((state: RootState) => state.language.language);
  const { i18n } = useTranslation();

  const handleChange = (e) => {
    dispatch(setLanguage(e.target.value));
  };

  useEffect(() => {
    i18n.changeLanguage(currentLang);
  }, [currentLang, i18n]);

  return (
    <Select
      value={currentLang}
      onChange={handleChange}
      size="small"
      variant="outlined"
      sx={{
        backgroundColor: 'white',
        borderRadius: '4px',
        fontSize: '13px',
        minWidth: '90px',
        ml: 1, 
      }}
    >
      <MenuItem value="en">English</MenuItem>
      <MenuItem value="zh">中文</MenuItem>
    </Select>
  );
};

export default LanguageSelector;
